import { InitPageStrict } from "../index";
import swal from "sweetalert";

class SubZoneBinFlag {
  private readonly token: string;

  constructor() {
    const meta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
    this.token = meta ? meta.content : "";
    document.addEventListener("change", (event) => this.onChange(event));
  }

  private onChange(event: Event): void {
    const box = event.target as HTMLInputElement;
    if (!box.classList || !box.classList.contains("sub-zone-bin")) { return; }

    const body = new URLSearchParams({ bin: String(box.checked) });
    box.disabled = true;
    fetch(box.dataset.url as string, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Accept": "application/json", "X-CSRF-Token": this.token },
      body,
    })
      .then((response) => response.json())
      .then((data: { bin?: boolean }) => {
        if (data.bin !== box.checked) { throw new Error("refused"); }
      })
      .catch(() => {
        box.checked = !box.checked;
        swal({ title: "Not saved", text: "The Bin setting could not be changed.", icon: "error" });
      })
      .then(() => { box.disabled = false; });
  }
}

export function LoadPage() {
  InitPageStrict("zones index", () => { new SubZoneBinFlag(); });
  InitPageStrict("sub_zones index", () => { new SubZoneBinFlag(); });
}
